function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
export default {
  /**
   * @param {string} value
   * @param {object} elements
   */
  fetchItemFromResponseValue: function fetchItemFromResponseValue(value, elements) {
    var fetchedElement = null;
    elements.map(function (element) {
      if (element.alias === value || element.alias === value.alias) {
        fetchedElement = element;
      }
      return true;
    });
    return fetchedElement;
  },
  /**
   * @param {object} listResponses
   * @param {object} elements
   * @param {function} dispatch
   */
  responseToDndListFormat: function responseToDndListFormat(alias, listResponses, elements, dispatch) {
    var _this = this;
    var formattedValue = {};
    Object.keys(listResponses).map(function (key) {
      var keyToFormat = key.replace(alias + '_', '');
      var index = keyToFormat.indexOf('mode_');
      var listKey = keyToFormat.substring(index + 5);
      var list = listKey.split('_');
      if (!formattedValue[list[0]]) {
        formattedValue[list[0]] = [];
      }
      formattedValue[list[0]][list[1]] = _this.fetchItemFromResponseValue(listResponses[key], elements);
      return true;
    });
    dispatch({
      type: 'all',
      value: formattedValue
    });
  },
  /**
   * @param {object} values
   */
  reducerValuesToResponseFormat: function reducerValuesToResponseFormat(values) {
    var formattedValues = {};
    var list = null;
    Object.keys(values).map(function (key) {
      if (_typeof(values[key]) !== 'object') {
        return null;
      }
      list = values[key];
      Object.keys(list).map(function (idx) {
        var value = list[idx];
        if (!value) {
          return false;
        }
        formattedValues["mode_".concat(key, "_").concat(idx)] = value.alias;
        return true;
      });
      return true;
    });
    return formattedValues;
  }
};